import {
  Box,
  Text,
  Table,
  FlexiPagination,
  Spacer,
  Input,
  Grid,
  Select,
  Loader,
} from "@flexisaf/flexibull2";
import useSchoolsGet from "../../../hooks/questions/useSchoolsGet";
import useQuizathonParticipants from "../../../hooks/quizathon/useQuizathonParticipants";
import QuizathonEmptyState from "../../../components/custom/QuizathonEmptyState";
import { useParams } from "react-router-dom";
import Theme from "../../../theme";
import { useNavigate } from "react-router-dom";
import { thousandFormatter } from "../../../utils/helpers";

const Participants = () => {
  const { id } = useParams();
  const { loadingSchools, schools } = useSchoolsGet();
  const {
    quizathonParticipants,
    loadingQuizathonParticipants,
    limit,
    setLimit,
    totalElements,
    page,
    setPage,
    pageOptions,
    searchText,
    setSearchText,
    setSelectSchool,
    selectSchool,
  } = useQuizathonParticipants({ quizathonId: id });
  const navigate = useNavigate();
  return (
    <Box>
      <Spacer space={20} />
      <Grid
        default="minmax(auto,40px) minmax(auto, 300px) minmax(auto, 300px)"
        alignItems="center"
      >
        <Box>
          <Text size="1rem">Filter:</Text>
        </Box>
        <Input
          type="text"
          iconLeft="saf-search-normal"
          placeholder={`Search By Name`}
          style={{ width: "100%" }}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />

        <Select
          block
          placeholder="Select University"
          required
          isLoading={loadingSchools}
          onChange={(e) => setSelectSchool({ ...selectSchool, value: e.value })}
          options={schools?.items?.map((item) => {
            return {
              label: item.name,
              value: item.id,
            };
          })}
        />
      </Grid>
      <>
        {loadingQuizathonParticipants ? (
          <Box pad="150px 0">
            <Loader color={Theme.PrimaryColor} section />
          </Box>
        ) : quizathonParticipants?.items?.length > 0 ? (
          <>
            <Table>
              <table>
                <thead>
                  <tr>
                    <th>S/No</th>
                    <th>Students Name</th>
                    <th>Institution</th>
                    <th>Score</th>
                  </tr>
                </thead>
                <tbody>
                  {quizathonParticipants?.items?.map((participant, index) => (
                    <tr
                      key={participant?.id}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(
                          `/quizathon-participant/${participant?.quizathon?.id}/${participant?.userInfo?.studentId}`
                        )
                      }
                    >
                      <td>
                        <Text>{index + 1}</Text>
                      </td>
                      <td style={{ color: Theme.PrimaryColor }}>
                        <Text>{`${participant?.userInfo?.firstName} ${participant?.userInfo?.lastName}`}</Text>
                      </td>
                      <td>
                        <Text>
                          {participant?.schoolInformation?.school?.name}
                        </Text>
                      </td>
                      <td>
                        <Text>
                          {thousandFormatter(participant?.totalScores)}
                        </Text>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Table>

            <FlexiPagination
              pageCounts={pageOptions}
              itemsDisplayed
              total={totalElements}
              pageSize={limit}
              onChange={(page) => {
                setPage(page);
              }}
              changePageSize={({ value }) => {
                setPage(1);
                setLimit(value);
              }}
              current={page}
            />
          </>
        ) : (
          <QuizathonEmptyState title="No Data Found" />
        )}
      </>
    </Box>
  );
};

export default Participants;
